// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7446e4a","484":"38d48ca7","828":"3464384d"}[chunkId] + ".chunk.js";
};